import { CALL_API } from '../middleware/ApiMiddleware';

export const FORCED_ABATEMENT_ACTIVITY_LIST_FETCH_REQUEST = 'FORCED_ABATEMENT_ACTIVITY_LIST_FETCH_REQUEST';
export const FORCED_ABATEMENT_ACTIVITY_LIST_FETCH_SUCCESS = 'FORCED_ABATEMENT_ACTIVITY_LIST_FETCH_SUCCESS';
export const FORCED_ABATEMENT_ACTIVITY_LIST_FETCH_FAILURE = 'FORCED_ABATEMENT_ACTIVITY_LIST_FETCH_FAILURE';

export const FORCED_ABATEMENT_ACTIVITY_FETCH_REQUEST = 'FORCED_ABATEMENT_ACTIVITY_FETCH_REQUEST';
export const FORCED_ABATEMENT_ACTIVITY_FETCH_SUCCESS = 'FORCED_ABATEMENT_ACTIVITY_FETCH_SUCCESS';
export const FORCED_ABATEMENT_ACTIVITY_FETCH_FAILURE = 'FORCED_ABATEMENT_ACTIVITY_FETCH_FAILURE';

export const FORCED_ABATEMENT_ACTIVITY_EDIT_REQUEST = 'FORCED_ABATEMENT_ACTIVITY_EDIT_REQUEST';
export const FORCED_ABATEMENT_ACTIVITY_EDIT_SUCCESS = 'FORCED_ABATEMENT_ACTIVITY_EDIT_SUCCESS';
export const FORCED_ABATEMENT_ACTIVITY_EDIT_FAILURE = 'FORCED_ABATEMENT_ACTIVITY_EDIT_FAILURE';

export const FORCED_ABATEMENT_ACTIVITY_CREATE_REQUEST = 'FORCED_ABATEMENT_ACTIVITY_CREATE_REQUEST';
export const FORCED_ABATEMENT_ACTIVITY_CREATE_SUCCESS = 'FORCED_ABATEMENT_ACTIVITY_CREATE_SUCCESS';
export const FORCED_ABATEMENT_ACTIVITY_CREATE_FAILURE = 'FORCED_ABATEMENT_ACTIVITY_CREATE_FAILURE';

export const FORCED_ABATEMENT_ACTIVITY_EDIT_SEQUENCE_FAILURE = 'FORCED_ABATEMENT_ACTIVITY_EDIT_SEQUENCE_FAILURE';
export const FORCED_ABATEMENT_ACTIVITY_EDIT_SEQUENCE_REQUEST = 'FORCED_ABATEMENT_ACTIVITY_EDIT_SEQUENCE_REQUEST';
export const FORCED_ABATEMENT_ACTIVITY_EDIT_SEQUENCE_SUCCESS = 'FORCED_ABATEMENT_ACTIVITY_EDIT_SEQUENCE_SUCCESS';

export const FORCED_ABATEMENT_ACTIVITY_ASSOCIATE_NOTICES_EDIT_FAILURE =
  'FORCED_ABATEMENT_ACTIVITY_ASSOCIATE_NOTICES_EDIT_FAILURE';
export const FORCED_ABATEMENT_ACTIVITY_ASSOCIATE_NOTICES_EDIT_REQUEST =
  'FORCED_ABATEMENT_ACTIVITY_ASSOCIATE_NOTICES_EDIT_REQUEST';
export const FORCED_ABATEMENT_ACTIVITY_ASSOCIATE_NOTICES_EDIT_SUCCESS =
  'FORCED_ABATEMENT_ACTIVITY_ASSOCIATE_NOTICES_EDIT_SUCCESS';

export const FORCED_ABATEMENT_ACTIVITY_ASSOCIATE_NOTICES_FETCH_FAILURE =
  'FORCED_ABATEMENT_ACTIVITY_ASSOCIATE_NOTICES_FETCH_FAILURE';
export const FORCED_ABATEMENT_ACTIVITY_ASSOCIATE_NOTICES_FETCH_REQUEST =
  'FORCED_ABATEMENT_ACTIVITY_ASSOCIATE_NOTICES_FETCH_REQUEST';
export const FORCED_ABATEMENT_ACTIVITY_ASSOCIATE_NOTICES_FETCH_SUCCESS =
  'FORCED_ABATEMENT_ACTIVITY_ASSOCIATE_NOTICES_FETCH_SUCCESS';

export const baseURL = 'xerce/config/forced-abatement-activities';

export const fetchForcedAbatementActivities = () => ({
  [CALL_API]: {
    endpoint: `${baseURL}`,
    method: 'get',
    authenticated: true,
    types: [
      FORCED_ABATEMENT_ACTIVITY_LIST_FETCH_REQUEST,
      FORCED_ABATEMENT_ACTIVITY_LIST_FETCH_SUCCESS,
      FORCED_ABATEMENT_ACTIVITY_LIST_FETCH_FAILURE,
    ],
  },
});

export const fetchForcedAbatementActivity = (faaId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${faaId}`,
    method: 'get',
    authenticated: true,
    types: [
      FORCED_ABATEMENT_ACTIVITY_FETCH_REQUEST,
      FORCED_ABATEMENT_ACTIVITY_FETCH_SUCCESS,
      FORCED_ABATEMENT_ACTIVITY_FETCH_FAILURE,
    ],
  },
});

export const editForcedAbatementActivity = (faaId: number, faaEditRequest: IConfigForcedAbatementEditRequest) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${faaId}`,
    method: 'put',
    body: faaEditRequest,
    authenticated: true,
    types: [
      FORCED_ABATEMENT_ACTIVITY_EDIT_REQUEST,
      FORCED_ABATEMENT_ACTIVITY_EDIT_SUCCESS,
      FORCED_ABATEMENT_ACTIVITY_EDIT_FAILURE,
    ],
  },
});

export const createForcedAbatementActivity = (faaCreateRequest: IConfigForcedAbatementRequest) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'post',
    body: faaCreateRequest,
    authenticated: true,
    types: [
      FORCED_ABATEMENT_ACTIVITY_CREATE_REQUEST,
      FORCED_ABATEMENT_ACTIVITY_CREATE_SUCCESS,
      FORCED_ABATEMENT_ACTIVITY_CREATE_FAILURE,
    ],
  },
});

export const editForcedAbatementActivitySequence = (sequence: number[]) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/sequence`,
    method: 'put',
    body: { sequence },
    authenticated: true,
    types: [
      FORCED_ABATEMENT_ACTIVITY_EDIT_SEQUENCE_REQUEST,
      FORCED_ABATEMENT_ACTIVITY_EDIT_SEQUENCE_SUCCESS,
      FORCED_ABATEMENT_ACTIVITY_EDIT_SEQUENCE_FAILURE,
    ],
  },
});

export const fetchAssociatedNotices = () => ({
  [CALL_API]: {
    endpoint: `${baseURL}/associate-notices`,
    method: 'get',
    authenticated: true,
    types: [
      FORCED_ABATEMENT_ACTIVITY_ASSOCIATE_NOTICES_FETCH_REQUEST,
      FORCED_ABATEMENT_ACTIVITY_ASSOCIATE_NOTICES_FETCH_SUCCESS,
      FORCED_ABATEMENT_ACTIVITY_ASSOCIATE_NOTICES_FETCH_FAILURE,
    ],
  },
});

export const updateAssociatedNotices = (noticeIds: number[]) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/associate-notices`,
    method: 'put',
    authenticated: true,
    body: { noticeIds },
    types: [
      FORCED_ABATEMENT_ACTIVITY_ASSOCIATE_NOTICES_EDIT_REQUEST,
      FORCED_ABATEMENT_ACTIVITY_ASSOCIATE_NOTICES_EDIT_SUCCESS,
      FORCED_ABATEMENT_ACTIVITY_ASSOCIATE_NOTICES_EDIT_FAILURE,
    ],
  },
});
